/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SlotActionsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of slot actions available
 */
define([], () => {
	class SlotActionsAPI {

		/**
		 * @function SlotActionsAPI#registerProvider
		 * @description Register a provider as a slot actions provider
		 * @param {name} name of the provider
		 * @param {provider} provider SlotAction provider to register and contribute to slot actions
		 */
		registerProvider(/* name, provider */) {}

		/**
		 * @function SlotActionsAPI#getSlotActionList
		 * @description Returns a list of slotActions available for a specific item given a data slot and an item index.
		 * @param {dataSlotId} id of the dataSlot
		 * @param {itemIndex} index of the dataItem
		 * @param {options} {actionOptions: {}, actionsToKeep: {}}
		 * @return {array} array containing all available actions
		 */
		getSlotActionList(/* dataSlotId, itemIndex, options */) {}

	}

	return SlotActionsAPI;
});